import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE = 'Northcoast AI Academy';

// Exact-match titles; dynamic segments fall through to prefix matching below.
const titles: Record<string, string> = {
  '/': SITE,
  '/start': 'Start here — free AI training',
  '/fix-it': 'Fix Your Computer with AI',
  '/shift': 'The Shift — a 3-minute AI challenge',
  '/bingo': 'Bias Bingo — discover your thinking blind spots',
  '/autopsy': 'Prompt Autopsy',
  '/spot-the-flaw': 'Spot the Flaw',
  '/orientation': 'Orientation Assessment',
  '/community': 'Community',
  '/login': 'Log in',
  '/register': 'Get started',
  '/dashboard': 'Dashboard',
  '/journal': 'Thinking Journal',
  '/profile': 'Profile',
  '/preferences': 'Preferences',
  '/close-reading': 'Close Reading practice',
  '/privacy': 'Privacy Policy',
  '/terms': 'Terms of Service',
  '/cookies': 'Cookie Policy',
  '/refund': 'Refund Policy',
  '/accessibility': 'Accessibility',
};

const prefixes: Array<[string, string]> = [
  ['/tracks/', 'Track'],
  ['/courses/', 'Course'],
  ['/lessons/', 'Lesson'],
  ['/forums/', 'Forum'],
  ['/threads/', 'Discussion'],
  ['/groups/', 'Study Group'],
  ['/cohorts/', 'Cohort'],
];

export default function RouteTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    const exact = titles[pathname];
    const prefixed = prefixes.find(([prefix]) => pathname.startsWith(prefix))?.[1];
    const title = exact ?? prefixed;
    document.title = title && title !== SITE ? `${title} · ${SITE}` : SITE;
  }, [pathname]);

  return null;
}
